import { render, staticRenderFns } from "./k-text-area.vue?vue&type=template&id=29c61861"
import script from "./k-text-area.vue?vue&type=script&lang=js"
export * from "./k-text-area.vue?vue&type=script&lang=js"
import style0 from "./k-text-area.vue?vue&type=style&index=0&id=29c61861&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports